function S() {
  var e = [], t = {};
  return {
    getSharedStrings: function() {
      return e;
    },
    getSharedString: function(n) {
      var r = t[n];
      return r === void 0 && (r = String(e.length), t[n] = r, e.push(n)), r;
    }
  };
}
export {
  S as default
};
//# sourceMappingURL=index.es246.js.map
